import React from 'react'

import { Caption } from 'ui/acro'

const NavbarLink = ({ ...rest }) => (
  <Caption variant='bold' as='a' ml={'16px'} mr={'16px'} {...rest} />
)

export default NavbarLink
